import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import type { Device, User } from '@/lib/types';

export function useUsers() {
  return useQuery({
    queryKey: ['users'],
    queryFn: () => api<User[]>('/api/auth/users'),
  });
}

export function useUserDevices(userId: number | null) {
  return useQuery({
    queryKey: ['user-devices', userId],
    queryFn: () => api<Device[]>(`/api/auth/users/${userId}/devices`),
    enabled: userId !== null,
  });
}

export function useAllDevices(enabled = true) {
  return useQuery({
    queryKey: ['devices', 'all'],
    queryFn: () => api<Device[]>('/api/devices/all'),
    enabled,
  });
}
